/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Extraction_CompleteInputs */



/**
* | output |
* | --- |
* | "Resource extraction complete. Uploading..." |
*
* @param {Ad_Extraction_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_extraction_complete = /** @type {((inputs?: Ad_Extraction_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Extraction_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction des ressources terminée. Chargement en cours...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ressourcenextraktion abgeschlossen. Hochladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione delle risorse completata. Caricamento in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечение ресурсов завершено. Загрузка...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extracción de recursos completada. Subiendo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("资源提取完成。正在上传……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リソースの抽出が完了しました。アップロード中です...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संसाधन निष्कर्षण पूर्ण हो गया है। अपलोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extração de recursos concluída. Enviando...")
	return /** @type {LocalizedString} */ ("Resource extraction complete. Uploading...")
});